'use strict'

/**
 * string 라이브러리
 */
module.exports = {
  /**-- isNotNull --**/
  isNotNull: (data) => {
    if (data !== null && data != 'null' && data != undefined && data != '') return true
    else return false
  },

  /**-- isNotNull --**/
  isNull: (data) => {
    if (data === null || data == 'null' || data == undefined || data === '') return true
    else return false
  },

  /**
   * 콤마 삭제
   * @param {string} data
   * @returns {string}
   */
  setDelComma: (data) => {
    return data.toString().replace(/[^0-9]/g, '')
  },

  /**
   * 핸드폰, 전화번호 유효성 체크
   * @param {string} p 핸드폰 번호
   */
  isCellPhone: (p) => {
    var regExp = /^(01[016789]{1}|02|0[3-9]{1}[0-9]{1})-?[0-9]{3,4}-?[0-9]{4}$/

    if (!regExp.test(p)) return false
    else return true
  },

  /**
   * 숫자인지 여부
   * @param v
   * @returns {boolean}
   */
  isNum: (v) => {
    var regNumber = /^[0-9]+$/gi

    if (regNumber.test(v)) return true
    else return false
  },

  /**
   * 특수문자 있는지 여부
   * @param str
   * @returns {boolean}
   */
  isSpecial: (str) => {
    var special_pattern = /[`~!@#$%^&*|\\'\\";:\\/?]/gi

    if (special_pattern.test(str)) return true
    else return false
  },

  /**
   * 유효성 체크
   * @param type
   * @param value
   * @param message
   * @returns {boolean}
   */
  regExpTest: (type, value) => {
    var regExp = ''
    switch (type) {
      case 'MOBILE':
        regExp = /^\d{3}-\d{3,4}-\d{4}$/
        break
      case 'MOBILE2':
        regExp = /(01[016789])(\d{4}|\d{3})\d{4}$/g
        break
      case 'HANGUL':
        regExp = /[가-힣]/
        break
      case 'EMPTY':
        regExp = /\s/g
        break
      case 'NUM':
        regExp = /^[0-9]+$/
        break
      case 'EMAIL':
        regExp = /^[0-9a-zA-Z]([-_\\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i
        break
      case 'ID':
        regExp = /^[a-zA-Z]+[a-zA-Z0-9]{3,30}$/g
        break
      case 'PASSWD':
        regExp = /^.*(?=.{8,30})(?=.*[0-9])(?=.*[a-zA-Z]).*$/
        break
    }

    if (!regExp.test(value) || value == undefined) return false
    else return true
  },

  /**
   * 쿠키 생성
   * @param cName
   * @param cValue
   * @param cDay
   */
  setCookie: (cName, cValue, cDay) => {
    var date = new Date()
    date.setTime(date.getTime() + cDay * 60 * 60 * 24 * 1000)
    document.cookie = cName + '=' + escape(cValue) + ';expires=' + date.toUTCString() + ';path=/'
  },

  setCookie2: (cName, cValue, cDay, domain) => {
    var date = new Date()
    date.setTime(date.getTime() + cDay * 60 * 60 * 24 * 1000)
    if (domain)
      document.cookie =
        cName + '=' + escape(cValue) + ';domain=' + domain + ';expires=' + date.toUTCString() + ';path=/'
    else document.cookie = cName + '=' + escape(cValue) + ';expires=' + date.toUTCString() + ';path=/'
  },

  /**
   * 쿠키 가저오기
   * @param cName
   * @returns {*}
   */
  getCookie: (cName) => {
    cName = cName + '='
    var cookieData = document.cookie
    var start = cookieData.indexOf(cName)
    var cValue = ''
    if (start != -1) {
      start += cName.length
      var end = cookieData.indexOf(';', start)
      if (end == -1) end = cookieData.length
      cValue = cookieData.substring(start, end)
    }
    return unescape(cValue)
  },

  /**
   * 숫자만 리턴
   * @param v
   */
  onlyNum: (v) => {
    return v.replace(/[^0-9]/g, '')
  },

  /**
   * 콤마 찍기
   * @param price
   * @returns {string}
   */
  setComma: (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  },

  /**
   * 타이머
   * @returns {{comSecond: string, fnCallback: function(), timer: string, domId: string, fnTimer: function(), fnStop: function()}}
   */
  timer: () => {
    return {
      comSecond: '',
      fnCallback: () => {},
      timer: '',
      domId: '',
      fnTimer: () => {
        const m = Math.floor(this.comSecond / 60) + ' ' + (this.comSecond % 60) + '' // 남은 시간 계산
        this.comSecond-- // 1초씩 감소
        this.domId.innerText = m
        if (this.comSecond < 0) {
          // 시간이 종료 되었으면..
          clearInterval(this.timer) // 타이머 해제
          alert('인증시간이 초과하였습니다. 다시 인증해주시기 바랍니다.')
        }
      },
      fnStop: () => {},
    }
  },

  /**
   * 바이트계산 ?
   * @param val 입력문자
   * @returns {string}
   */
  getBytes: (val) => {
    // 입력받은 문자열을 escape() 를 이용하여 변환한다.
    // 변환한 문자열 중 유니코드(한글 등)는 공통적으로 %uxxxx로 변환된다.
    var temp_estr = escape(val)
    var s_index = 0
    var e_index = 0
    var temp_str = ''
    var cnt = 0

    // 문자열 중에서 유니코드를 찾아 제거하면서 갯수를 센다.
    while ((e_index = temp_estr.indexOf('%u', s_index)) >= 0) {
      // 제거할 문자열이 존재한다면
      temp_str += temp_estr.substring(s_index, e_index)
      s_index = e_index + 6
      cnt++
    }

    temp_str += temp_estr.substring(s_index)

    temp_str = unescape(temp_str) // 원래 문자열로 바꾼다.

    // 유니코드는 2바이트 씩 계산하고 나머지는 1바이트씩 계산한다.
    return cnt * 2 + temp_str.length + ''
  },

  mobileOs: () => {
    const varUA = navigator.userAgent.toLowerCase() //userAgent 값 얻기

    if (varUA.match('android') != null) {
      return 'ANDROID'
    } else if (varUA.indexOf('iphone') > -1 || varUA.indexOf('ipad') > -1 || varUA.indexOf('ipod') > -1) {
      return 'IOS'
    } else {
      return ''
    }
  },

  /**
   * 쿠키 생성
   * @param cName
   * @param cValue
   * @param cDay
   * @param domin
   */
  setDomainCookie: (cName, cValue, cDay, domain) => {
    var date = new Date()
    date.setTime(date.getTime() + cDay * 60 * 60 * 24 * 1000)
    if (domain)
      document.cookie =
        cName + '=' + escape(cValue) + ';domain=' + domain + ';expires=' + date.toUTCString() + ';path=/'
    else document.cookie = cName + '=' + escape(cValue) + ';expires=' + date.toUTCString() + ';path=/'
  },

  /**
   * 휴대폰 번호 하이픈
   * @param num
   * @param type
   * @returns {string}
   */
  phoneNumberHyphenAdd: (num, type) => {
    let formatNum = ''

    if (this.isNotNull(num)) {
      num = num.replace(/[^0-9]/g, '')
      if (num.length == 11) {
        if (type == 0) {
          formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3')
        } else {
          formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
        }
      } else if (num.length == 8) {
        formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2')
      } else if (num.length == 9) {
        if (type == 0) {
          formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-****-$3')
        } else {
          formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
        }
      } else {
        if (num.indexOf('02') == 0) {
          if (type == 0) {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3')
          } else {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
          }
        } else {
          if (type == 0) {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3')
          } else {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
          }
        }
      }
    }

    return formatNum
  },

  makeQueryString: (data) => {
    let queryParam = ''
    Object.keys(data).forEach((key) => {
      const value = data[key]

      if (value) {
        if (queryParam === '') queryParam += '?'
        else queryParam += '&'

        queryParam += key + '=' + data[key]
      }
    })

    return queryParam
  },

  setDurationToTime(duration) {
    var sec_num = parseInt(duration, 10) // don't forget the second param
    var hours = Math.floor(sec_num / 3600)
    var minutes = Math.floor((sec_num - hours * 3600) / 60)
    var seconds = sec_num - hours * 3600 - minutes * 60

    let text = ''
    if (hours > 0) text += hours + (hours > 1 ? ' hours ' : ' hour ')
    if (minutes > 0) text += minutes + (minutes > 1 ? ' mins ' : ' min ')
    else if (sec_num > 0) text += seconds + (seconds > 1 ? ' secs ' : ' sec ')
    if (sec_num === 0) text = '0 sec'

    return text && text !== '' ? text : '0 sec'
  },

  time(second) {
    let seconds = parseInt(second.toString())
    let hour = parseInt(seconds / 3600)
    let min =
      parseInt((seconds % 3600) / 60) < 10 ? '0' + parseInt((seconds % 3600) / 60) : parseInt((seconds % 3600) / 60)
    let sec = seconds % 60 < 10 ? '0' + (seconds % 60) : seconds % 60
    return `${hour > 0 ? hour + ':' : ''}${min}:${sec}`
  },

  timeToSecond(second) {
    let time = second.split(':')
    let min = Number.parseInt(time[0]) * 60
    let sec = Number.parseInt(time[1])
    return sec + min
  },

  numFormat(variable) {
    variable = Number(variable).toString()
    if (Number(variable) < 10 && variable.length === 1) variable = '0' + variable
    return variable
  },

  /**
   * 이미지 경로 구성
   * @param co
   * @param size
   * @returns {*}
   */
  getImgUrl(co, size) {
    let images = require.context('@/assets/img/', false, /\.png$/)
    if (size === 0) {
      return images('./' + co + '.png')
    } else {
      return images('./' + co + '@' + size + 'x.png')
    }
  },

  /**
   * image srcset value return
   * @param co
   * @returns {string}
   */
  getSrcSet(co) {
    return this.getImgUrl(co, 2) + ' 2x, ' + this.getImgUrl(co, 3) + ' 3x'
  },
  isSafari() {
    return (
      navigator.userAgent.toLowerCase().indexOf('chrome') === -1 &&
      navigator.userAgent.toLowerCase().indexOf('safari') !== -1
    )
  },
  // isIphone() {
  //   return navigator.userAgent.toLowerCase().indexOf('iphone') !== -1
  // },
  isIphone() {
    return /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase())
  },
  isMacOS() {
    var filter = 'mac|macintel'
    return navigator.platform && 0 <= filter.indexOf(navigator.platform.toLowerCase())
  },
  isChrome() {
    var filter = 'win16|win32|win64|mac|macintel|linux x86_64'
    if (navigator.platform) {
      if (0 > filter.indexOf(navigator.platform.toLowerCase())) {
        return 'Mobile'
      }
    }
    const agt = navigator.userAgent.toLowerCase()
    if (agt.indexOf('chrome') !== -1) return 'Chrome'
    if (agt.indexOf('opera') !== -1) return 'Opera'
    if (agt.indexOf('staroffice') !== -1) return 'Star Office'
    if (agt.indexOf('webtv') !== -1) return 'WebTV'
    if (agt.indexOf('beonex') !== -1) return 'Beonex'
    if (agt.indexOf('chimera') !== -1) return 'Chimera'
    if (agt.indexOf('netpositive') !== -1) return 'NetPositive'
    if (agt.indexOf('phoenix') !== -1) return 'Phoenix'
    if (agt.indexOf('firefox') !== -1) return 'Firefox'
    if (agt.indexOf('safari') !== -1) return 'Safari'
    if (agt.indexOf('skipstone') !== -1) return 'SkipStone'
    if (agt.indexOf('netscape') !== -1) return 'Netscape'
    if (agt.indexOf('mozilla/5.0') !== -1) return 'Mozilla'
    if (agt.indexOf('msie') !== -1) {
      let rv = -1
      if (navigator.appName === 'Microsoft Internet Explorer') {
        let ua = navigator.userAgent
        var re = new RegExp('MSIE ([0-9]{1,}[.0-9]{0,})')
        if (re.exec(ua) != null) rv = parseFloat(RegExp.$1)
      }
      return 'Internet Explorer ' + rv
    }
  },
  isMobile() {
    return /iphone|ipad|ipod|android/i.test(navigator.userAgent.toLowerCase())
  },
  format(content, arg) {
    var formatted = content,
      i = 0
    while (/%s/.test(formatted)) formatted = formatted.replace('%s', arg[i++])
    return formatted
  },
  chkFullScreen() {
    return (
      (document.fullScreenElement !== undefined && document.fullScreenElement === null) ||
      (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) ||
      (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
      (document.webkitFullscreenElement !== undefined && document.webkitFullscreenElement !== null)
    )
  },
  setFullScreen(elem) {
    let isFullScreen = false
    if (
      (document.fullScreenElement !== undefined && document.fullScreenElement === null) ||
      (document.msFullscreenElement !== undefined && document.msFullscreenElement === null) ||
      (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
      (document.webkitIsFullScreen !== undefined && !document.webkitIsFullScreen)
    ) {
      isFullScreen =
        elem.requestFullScreen || elem.mozRequestFullScreen || elem.webkitRequestFullScreen || elem.msRequestFullscreen
      if (elem.requestFullScreen) {
        elem.requestFullScreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      }
    }
    return isFullScreen
  },
  setCancelFullScreen() {
    if (document.cancelFullScreen) {
      document.cancelFullScreen()
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen()
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
  },
}
